<script>
    import {mapState} from "vuex";
    import {last} from "eslint-plugin-vue/lib/utils/indent-utils";
    import {CommonMixin} from "@/mixins/commonMethods";

    export default {
        name: "Option input",
        mixins: [CommonMixin],
        props: {
            inputType: {
                type: String,
                default: "base",
                validator(value) {
                    return ['base', 'select', 'price', 'name', 'season'].includes(value);
                },
            },
            headText: {
                type: String
            },
            inputPlaceholder: {
                type: String,
                default: ''
            },
            modelVariable: {
                type: String
            },
            selectStore: {
                type: String,
                default: ''
            },
            defaultValue: {
                type: [Number, String, Array],
                default: ''
            },
            value: {

            }
        },
        data: () => ({
            searchText: '',
            isColorActive: {},
            activeColors: [],
            isError: 'false',
            errorText: "",
            defaultVal: "",
        }),
        computed: {
            ...mapState([
                'conditions', 'colors', 'brands', 'productTypes', 'pageTypes', 'statuses'
            ]),
            users() { // новое имя
                return this.$store.state.user.users || [];
            },
            storeSizes() { // новое имя
                return this.$store.state.sizes || [];
            },
            inputValue() {
                return this.inputType === 'select' ? 'Не выбрано' : ''
            },
            filteredItems() {
                if (!this.selectStore) return ''
                let dataStore = this[this.selectStore]

                if (this.selectStore === 'sizes') dataStore = this.storeSizes
                if (!this.searchText) {
                    return dataStore; // Если строка пустая, возвращаем весь массив
                }

                // Фильтруем объекты по всем свойствам
                return dataStore.filter(item => {
                    return Object.values(item).some(value =>
                        String(value).toLowerCase().includes(this.searchText.toLowerCase())
                    );
                });
            }
        },
        methods: {
            inputCallback(ev) {
                this.$emit('update:modelValue', ev.target.value, this.modelVariable)

                if (!this.selectStore) return
                this.searchText = ev.target.value

                if (this.inputType === 'select') {
                    if (!this.searchText) {
                        this.$refs[this.selectStore].style.display = "none"
                    } else {
                        this.$refs[this.selectStore].style.display = "block"
                    }
                }

                if (this.filteredItems.length === 0) this.$refs[this.selectStore].style.display = "none"

                this.setCoordsToLists()
            },
            setCoordsToLists() {
                const input = this.$refs[`input-${this.selectStore}`]
                const selectItems = this.$refs[this.selectStore]

                if (selectItems && input) {
                    selectItems.style.position = "absolute"
                    selectItems.style.top = input.getBoundingClientRect().bottom + window.scrollY + "px"
                    selectItems.style.width = input.getBoundingClientRect().width + "px"
                }
            },
            setValueCallback(ev) {
                const input = this.$refs[`input-${this.selectStore}`]
                const selectItems = this.$refs[this.selectStore]

                if (input && selectItems) {

                    if (ev.target.classList.contains("value-txt")) {
                        this.defaultVal = ev.target.textContent
                    } else if (ev.target.querySelector('span.value-txt')) {
                        this.defaultVal = ev.target.querySelector('span.value-txt').textContent
                    } else if (ev.target.tagName === "SPAN") {
                        this.defaultVal = ev.target.parentNode.querySelector("span.value-txt").textContent
                    }

                    selectItems.style.display = "none"
                    this.$emit('update:modelValue', this.defaultVal, this.modelVariable)
                    this.$emit('update:isError', 'false', this.modelVariable)
                    this.errorText = ""
                }
            },
            toggleColorActive(e, ind, color) {
                if (!this.isColorActive[`color-${ind}`]) this.isColorActive[`color-${ind}`] = true
                else this.isColorActive[`color-${ind}`] = !this.isColorActive[`color-${ind}`]

                if (this.isColorActive[`color-${ind}`]) this.activeColors.push(color)
                if (!this.isColorActive[`color-${ind}`]) {
                    const index = this.activeColors.findIndex(item => item.ID === color.ID);
                    if (index !== -1) {
                        this.activeColors.splice(index, 1)
                    }
                }

                this.$emit('update:modelValue', this.activeColors, this.modelVariable)
            },
            validateInput(e, ref) {
                let value = e.target.value;

                if (value === "") {
                    this.isError = 'true'
                    this.errorText = "Пустое поле"
                    this.$emit('update:isError', this.isError, this.modelVariable)
                    return
                } else {
                    this.isError = 'false'
                    this.$emit('update:isError', this.isError, this.modelVariable)
                }

                if (this.inputType === "select") {
                    let isFind = false
                    let dataStore = this.$refs[ref].querySelectorAll("span")

                    for (let elem of dataStore) {
                        if (elem.textContent === value) {
                            isFind = true
                        }
                    }

                    if (isFind) {
                        this.isError = 'false'
                    } else {
                        this.isError = 'true'
                        this.errorText = "Необходимо выбрать значение из списка"
                    }
                } else if (this.inputType === "color") {
                    this.activeColors ? this.isError = 'false' : this.isError = 'true'
                } else if (this.inputType === "name") {
                    const firstChar = value.charAt(0);
                    const lastChar = value.charAt(value.length - 1);

                    if (firstChar !== "«" && lastChar !== "*") {
                        e.target.value = "«" + value
                        value = e.target.value
                    }

                    if (lastChar !== "»" && lastChar !== "*") {
                        e.target.value = value + "»"
                        value = e.target.value
                    }

                    if (lastChar === "*") {
                        e.target.value = value.slice(0, -1)
                    }

                    this.$emit('update:modelValue', e.target.value, this.modelVariable)
                } else if (this.inputType === "season") {
                    const regex = /^\d{4}\/\d{4}$/;
                    if (!regex.test(value)) {
                        this.isError = 'true'
                        this.errorText = "Неверный формат данных"
                    } else if (parseInt(value.split("/")[0]) > 2050
                        || parseInt(value.split("/")[1]) > 2050
                        || parseInt(value.split("/")[1]) < parseInt(value.split("/")[0])) {
                        this.isError = 'true'
                        this.errorText = "Проверьте правильность введенного сезона"
                    } else {
                        this.isError = 'false'
                    }
                }

                if (this.isError === 'false') this.errorText = ""

                this.$emit('update:isError', this.isError, this.modelVariable)
            },

            setDefaultColors() {
                if (this.selectStore === 'colors') {

                    for (let [ind, color] of this.$refs[this.selectStore].querySelectorAll(".color-elem").entries()) {
                        for (let value of this.defaultValue) {

                            const arrayRgb = color.style.background.replace(/[^,\d]/g, '').split(',').map(Number)
                            const hexColor = this.rgbToHex(arrayRgb[0], arrayRgb[1], arrayRgb[2])

                            if (hexColor.toUpperCase() === value["HEX"]) {
                                this.isColorActive["color-"+(ind)] = true
                                this.activeColors.push({
                                    ID: ind+1,
                                    "Цвет": value["Цвет"],
                                    "Код": value["HEX"]
                                })
                            }
                        }
                    }
                }
            }
        },
        mounted() {
            this.defaultVal = this.defaultValue
            if (this.defaultValue) {
                this.$emit('update:isError', 'false', this.modelVariable)
                this.errorText = ""
            }
            this.setDefaultColors()
        },
        updated() {
            this.setDefaultColors()
        },
        watch: {
            defaultValue: {
                handler(newValue, oldValue) {
                    if (
                        typeof newValue === 'object' && typeof oldValue === 'object' &&
                        JSON.stringify(newValue) !== JSON.stringify(oldValue)
                    ) {

                        if (this.activeColors.length === 0) {
                            // this.setDefaultColors()
                        }

                        // if (this.defaultValue) {
                        //     this.$emit('update:isError', 'false', this.modelVariable)
                        //     this.errorText = ""
                        // }
                        this.$forceUpdate();
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<template>
    <span class="option-elem-label">{{ headText }}</span>
    <div class="input-elem" v-if="selectStore !== 'colors'">
        <input type="text"
               :ref="`input-${selectStore}`"
               :placeholder="inputPlaceholder || inputValue"
               @input="inputCallback($event)"
               @click="setCoordsToLists()"
               @change="validateInput($event, selectStore)"

               v-model="defaultVal"
               :data-type="inputType"
        >
        <span class="error-text" v-if="errorText">{{ errorText }}</span>
    </div>
    <div :ref="selectStore"
         :class="['elems-container', selectStore === 'colors' ? 'colors-container' : '']"
         v-if="inputType === 'select' && selectStore"
    >
        <div v-for="(el, ind) in filteredItems" @click="setValueCallback($event)">
            <div v-if="selectStore === 'users'" class="user-container">
                <span class="user-name">{{ el["Имя"] }}</span>
                <span class="user-email value-txt">{{ el["Email"] }}</span>
            </div>
            <div v-if="selectStore === 'brands'">
                <span class="brand-name value-txt">{{ el["Бренд"] }}</span>
            </div>
            <div v-if="selectStore === 'sizes'">
                <span class="size-name value-txt">{{ el["Размер"] }}</span>
            </div>
            <div v-if="selectStore === 'conditions'">
                <span class="condition-name value-txt">{{ el["Состояние"] }}</span>
            </div>
            <div v-if="selectStore === 'productTypes'">
                <span class="product-type-name value-txt">{{ el["Тип продукта"] }}</span>
            </div>
            <div v-if="selectStore === 'pageTypes'">
                <span class="page-type-name value-txt">{{ el["Тип"] }}</span>
            </div>
            <div v-if="selectStore === 'statuses'">
                <span class="status-name value-txt">{{ el["Статус"] }}</span>
            </div>
            <div v-if="selectStore === 'colors'">
                <div :ref="`color-${ind}`" class="color-elem" :style="'background:' + el['Код']" @click="toggleColorActive($event, ind, el)">
                    <div class="color-active" v-if="isColorActive[`color-${ind}`]">
                        <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.69632 8.92649L0.5 4.73017L1.54908 3.68109L4.69632 6.82833L11.4509 0.0737305L12.5 1.12281L4.69632 8.92649Z" fill="white"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

.option-elem .option-elem-label {
        font-size: 18px;
        font-weight: 500;
        color: $black;
    }

    .elems-container:not(.colors-container) {
        display: none;
        padding: 4px;
        font-size: 14px;
        position: relative;
        box-sizing: border-box;
        box-shadow: $shadow;
        border-radius: 10px;
        background: $white;
        max-height: 150px;
        overflow-y: scroll;
    }

    .elems-container:not(.colors-container) > * {
        padding: 8px;
        border-radius: 10px;
    }

    .elems-container:not(.colors-container) > *:hover {
        background: $silver;
    }

    .elems-container > *:not(:last-child) {
        margin-bottom: 5px;
    }

    .user-container {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
    }

    .user-email {
        font-size: 11px;
        color: gray;
        text-decoration: underline;
    }

    .elems-container.colors-container {
        box-shadow: none;
        position: static;
        padding: 0;
        border-radius: 0;
    }

    .colors-container {
        margin-top: 2%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        gap: 2%;
        row-gap: 4px;
    }

    .colors-container > div {
        max-width: 35px;
        max-height: 35px;
    }

    .color-elem {
        display: inline-block;
        width: 35px;
        height: 35px;
        max-width: 35px;
        max-height: 35px;
        border: 1px solid $gray;
        border-radius: 100px;

        cursor: pointer;
    }

    .color-active {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        border-radius: 100px;
        background: rgba(109, 111, 113, 0.8);
        //background-blend-mode: difference;
    }

    .input-elem {
        display: flex;
        flex-direction: column;
        gap: 5px
    }

    .input-elem .error-text {
        font-size: 10px;
        color: $purple
    }
</style>
